"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ButtonWithIcon = (props) => {
    return ((0, jsx_runtime_1.jsxs)("button", { type: props.type || 'button', onClick: props.onClick, disabled: props.disabled, className: props.className || `btn ${props.small ? 'btn-sm' : ''} btn-${props.color || 'primary'} m-1`, children: [props.loading
                ? (0, jsx_runtime_1.jsx)("i", { className: 'spinner-border text-danger ' })
                : (0, jsx_runtime_1.jsx)("i", { className: props.icon }), (0, jsx_runtime_1.jsx)("span", { className: 'ml-2', children: props.name })] }));
};
exports.default = ButtonWithIcon;
